import * as RadixTooltip from '@radix-ui/react-tooltip';
import cn from 'classnames';
import { FC, type HTMLAttributes, MouseEventHandler, ReactNode } from 'react';

import styles from './PrimaryTooltip.module.scss';

type PrimaryTooltipPropsType = {
  content: ReactNode;
  className?: string;
  triggerClassName?: string;
  triggerProps?: Pick<
    HTMLAttributes<HTMLDivElement>,
    'aria-label' | 'role' | 'tabIndex'
  >;
  children?: ReactNode;
  delayDuration?: number;
  portalContainer?: RadixTooltip.TooltipPortalProps['container'];
  side?: RadixTooltip.TooltipContentProps['side'];
  sideOffset?: number;
  onTriggerClick?: MouseEventHandler<HTMLDivElement> | undefined;
};

export const PrimaryTooltip: FC<PrimaryTooltipPropsType> = (props) => {
  const {
    className,
    triggerClassName,
    triggerProps,
    children,
    content,
    delayDuration = 0,
    portalContainer,
    side = 'top',
    sideOffset = 4,
    onTriggerClick,
  } = props;

  return (
    <RadixTooltip.Root delayDuration={delayDuration}>
      <RadixTooltip.Trigger asChild>
        <div
          {...triggerProps}
          className={cn(styles.tooltipTrigger, triggerClassName)}
          onClick={onTriggerClick}
        >
          {children}
        </div>
      </RadixTooltip.Trigger>

      <RadixTooltip.Portal container={portalContainer}>
        <RadixTooltip.Content
          className={cn(styles.tooltipContent, 'p3', className)}
          side={side}
          sideOffset={sideOffset}
        >
          {content}
          <RadixTooltip.Arrow asChild>
            <div className={cn(styles.tooltipArrow)} />
          </RadixTooltip.Arrow>
        </RadixTooltip.Content>
      </RadixTooltip.Portal>
    </RadixTooltip.Root>
  );
};
